// contribution 지급 기준
const ContributionBasis = {
    FIXED_STANDARD: 'FIXED_STANDARD', // 연봉에서 추산된 월 급여 기준으로 구함 
    ACTUAL_PAYOUT: 'ACTUAL_PAYOUT', // 실지급금 기준 
};

const contractType = [
    {
        text: 'Regular',
        value: 'FULL_TIME',
        isRegular: true,
        topDownBase: true,
        ContributionBasis: ContributionBasis.FIXED_STANDARD,
    },
    {
        text: 'Regular (Daily wage)',
        value: 'DAILY_WAGE',
        isRegular: true,
        topDownBase: true,
        ContributionBasis: ContributionBasis.ACTUAL_PAYOUT,
    },
    {
        text: 'Probationary',
        value: 'PROBATION',
        isRegular: true,
        topDownBase: true,
        ContributionBasis: ContributionBasis.FIXED_STANDARD,
    },
    {
        text: 'Contractual',
        value: 'FIXED_TERM_CONTRACT',
        isRegular: true,
        topDownBase: true,
        ContributionBasis: ContributionBasis.FIXED_STANDARD,
    },
    {
        text: 'Hourly-paid',
        value: 'HOURLY_WAGE',
        isRegular: true,
        topDownBase: false,
        ContributionBasis: ContributionBasis.FIXED_STANDARD,
    },
    {
        text: 'Project-based',
        value: 'PROJECT_BASE',
        isRegular: true,
        topDownBase: true,
        ContributionBasis: ContributionBasis.FIXED_STANDARD,
    },
    {
        text: 'Outsourced',
        value: 'OUTSOURCE',
        isRegular: true,
        topDownBase: true,
        ContributionBasis: ContributionBasis.FIXED_STANDARD,
    },
    {
        text: 'Temporary(Casual)',
        value: 'TEMPORARY',
        isRegular: true,
        topDownBase: true,
        ContributionBasis: ContributionBasis.FIXED_STANDARD,
    },
    {
        text: 'Part-time',
        value: 'PART_TIME',
        isRegular: false,
        topDownBase: false,
        ContributionBasis: null,
    },
    {
        text: 'Consultant',
        value: 'CONSULTANT',
        isRegular: false,
        topDownBase: false,
        ContributionBasis: null,
    },
];



const status = [
    { text: 'Active', value: 'ACTIVE' },
    { text: 'On Leave', value: 'ON_LEAVE' },
    { text: 'Resigned', value: 'RESIGNED' },
];

const leaveTypes = [
    { text: 'Leave of absence', value: 'LEAVE_OF_ABSENCE' },
    { text: 'Maternity Leave', value: 'MATERNITY_LEAVE' },
];

const gender = [
    {
        text: 'Male',
        value: 'M',
    },
    {
        text: 'Female',
        value: 'F',
    },
];

const maritalStatus = [
    {
        text: 'Married',
        value: 'M',
    },
    {
        text: 'Single',
        value: 'S',
    },
];

const graduationCategory = [
    {
        text: 'Graduated',
        value: 'Graduated',
    },
    {
        text: 'Attending',
        value: 'Attending',
    },
    {
        text: 'Leave of absence',
        value: 'Leave of absence',
    },
    {
        text: 'Expelled',
        value: 'Expelled',
    },
    {
        text: 'Suspended',
        value: 'Suspended',
    },
];

const educationTypes = [
    {
        text: 'College / Univ / Graduate School / Others',
        value: 'College / Univ / Graduate School / Others',
    },
    { text: 'High School', value: 'High School' },
    { text: 'Middle School', value: 'Middle School' },
    { text: 'Elementary', value: 'Elementary' },
];

const countryOptions = [
    {
        text: 'Philippines',
        value: 'philippines',
    },
];

const featureName = {
    WORK_SCHEDULE: 'WORK_SCHEDULE',
    PAYROLL: 'PAYROLL',
    WALLET_CATEGORY: 'WALLET_CATEGORY',
    SUB_ADMIN: 'SUB_ADMIN',
};

export {
    status,
    gender,
    maritalStatus,
    graduationCategory,
    contractType,
    leaveTypes,
    educationTypes,
    countryOptions,
    featureName,
    ContributionBasis,
};
